/**
 * Parse the url by removing the doubleSlashes from the second occurrence
 */
export const parseUrlFromDoubleSlashes = (url: string): string => url.replace(/([^:]\/)\/+/g, '$1');
